import { render, staticRenderFns } from "./DocumentLibrary.vue?vue&type=template&id=4d84c0a1&scoped=true&"
import script from "./DocumentLibrary.vue?vue&type=script&lang=js&"
export * from "./DocumentLibrary.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLibrary.vue?vue&type=style&index=0&id=4d84c0a1&lang=stylus&scoped=true&"
import style1 from "./DocumentLibrary.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d84c0a1",
  null
  
)

export default component.exports